import React, { useState } from 'react';
import './Form.css';
import './PaymentForm.css';
import logo from './logo.png';
import check from './CHECK.webp';

function PaymentForm({ totalCost }) {
  console.log("PaymentForm - totalCost:", totalCost);
  const [cardNumber, setCardNumber] = useState('');
  const [expiryDate, setExpiryDate] = useState('');
  const [cvv, setCvv] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);
  const [isSuccessful, setIsSuccessful] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsProcessing(true);
    setTimeout(() => {
      setIsProcessing(false);
      setIsSuccessful(true);
    }, 3000);
  };

  return (
    <div>
      <div className="header-container">
        <img src={logo} alt="Puerto Vallarta Logo" style={{ width: '350px' }} />
        {(!isProcessing && !isSuccessful) && (
          <h3>Impuesto de Visitantes</h3>
        )}
        {(!isProcessing && !isSuccessful) && (
          <div className="price-container" style={{ backgroundColor: 'rgb(226, 207, 167)', display: 'flex', flexWrap: 'wrap', gap: '8px', justifyContent: 'center' }}>
            <p className="price-text" style={{ textAlign: 'left' }}>Total a pagar: ${totalCost} MXN</p>
          </div>
        )}
      </div>
      {isProcessing ? (
        <div className="processing-payment">
          <p>Procesando pago...</p>
          <div className="loader"></div>
        </div>
      ) : isSuccessful ? (
        <div className="payment-success" style={{textAlign: 'center'}}>
          <img src={check} alt="Pago Exitoso" style={{width: '150px'}} />
          <p>Pago realizado con éxito!</p>
          <p>El comprobante ha sido enviado a su correo electrónico.</p>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="passport-form">
          <div>
            <label htmlFor="cardNumber">Número de tarjeta:</label>
            <input
              type="number"
              id="cardNumber"
              value={cardNumber}
              onChange={(e) => setCardNumber(e.target.value)}
              placeholder="XXXX XXXX XXXX XXXX"
              pattern="[0-9]*"
            />
          </div>
          <div>
            <label htmlFor="expiryDate">Fecha de Expiración:</label>
            <input
              type="text"
              id="expiryDate"
              value={expiryDate}
              onChange={(e) => setExpiryDate(e.target.value)}
              placeholder="MM/YY"
            />
          </div>
          <div>
            <label htmlFor="cvv">CVV:</label>
            <input
              type="text"
              id="cvv"
              value={cvv}
              onChange={(e) => setCvv(e.target.value)}
              placeholder="123"
            />
          </div>
          <div className="card-logos">
            <img src="https://img.icons8.com/color/48/000000/visa.png" alt="Visa" />
            <img src="https://img.icons8.com/color/48/000000/mastercard.png" alt="Mastercard" />
            <img src="https://img.icons8.com/color/48/000000/amex.png" alt="American Express" />
          </div>
          <button type="submit" disabled={isProcessing}>Pay</button>
        </form>
      )}
      <footer>
        <p>PRESIDENCIA MUNICIPAL: Independencia #123, Col. Centro, C.P. 48300, Puerto Vallarta. Teléfono: 322 222 0102 y 322 223 2500</p>
        <p>UNIDAD MUNICIPAL ADMINISTRATIVA: Av. Mezquital #604, Col. Portales, C.P.48315, Puerto Vallarta. Teléfonos: 322 178 8000 y 322 226 8080</p>
      </footer>
    </div>
  );
}

export default PaymentForm;
